const ResumeTypes = {
    FETCH_START:    '[SERVERS][RESUME] FETCH START',
    FETCH_SUCCESS:  '[SERVERS][RESUME] FETCH SUCCESS',
    FETCH_FAILURE:  '[SERVERS][RESUME] FETCH FAILURE'
};

export default ResumeTypes;